import React, { useCallback, useState } from 'react';

import BlueprintArticleSection from './BlueprintArticleSection';
import BlueprintHero from './BlueprintHero';
import BlueprintTitvSection from './BlueprintTitvSection';
import BlueprintVideoPlayer from './BlueprintVideoPlayer';
import BlueprintVideoSection from './BlueprintVideoSection';
import { Section, SectionItem } from './types';

interface BlueprintContentProps {
  sections: Section[];
}

const SECTION_COMPONENTS: Record<
  string,
  React.ComponentType<{ section: Section; onPlayVideo?: (item: SectionItem) => void }>
> = {
  video: BlueprintVideoSection,
  article: BlueprintArticleSection,
  titv: BlueprintTitvSection,
};

const BlueprintContent = ({ sections }: BlueprintContentProps) => {
  const [activeVideo, setActiveVideo] = useState<SectionItem | null>(null);

  const handlePlayVideo = useCallback((item: SectionItem) => {
    setActiveVideo(item);
  }, []);

  const handleCloseVideo = useCallback(() => {
    setActiveVideo(null);
  }, []);

  return (
    <main className="min-h-screen bg-white">
      <BlueprintHero sections={sections} />
      <div className="mx-auto max-w-[1256px] px-16 sm:px-24 lg:px-0">
        <div className="flex flex-col gap-64 pb-80">
          {sections.map((section) => {
            const Component = SECTION_COMPONENTS[section.sectionType];
            if (!Component) return null;
            return <Component key={section.id} section={section} onPlayVideo={handlePlayVideo} />;
          })}
        </div>
      </div>
      {activeVideo?.videoUrl && (
        <BlueprintVideoPlayer
          videoUrl={activeVideo.videoUrl}
          title={activeVideo.title || ''}
          appsUsed={activeVideo.metadata?.appsUsed || []}
          onClose={handleCloseVideo}
        />
      )}
    </main>
  );
};

export default BlueprintContent;
